import { PrototypeViewErrorCode } from '../types'

export function getErrorMessage(code: PrototypeViewErrorCode): string {
  switch (code) {
    case 'artboard_not_found':
      return 'This artboard does not exist.'
    case 'image_preload_error':
      return 'Failed to load the Prototype images.'
    case 'invalid_manifest':
      return 'Prototype file is invalid.'
    case 'network_error':
      return 'Something went wrong.'
    case 'offline':
      return 'Check your connection and reload the page.'
    case 'query_error':
      return 'Failed to load the Prototype data.'
    default:
      return 'Something went wrong.'
  }
}
